module.exports = __webpack_public_path__ + "static/media/napoleon-3.9b25ef86.png";